import { Grid } from "@mui/material"
import React from "react"
import { ReportFormDrawerExportFiltersSection as CommonExportFiltersSection } from "Pages/ReportsAlerts/Reports/Common/Page/Drawer/Sections"
import SheetsField from "Pages/ReportsAlerts/Reports/OneWays/Page/Drawer/Sections/Sheets"

// The Common section plus the workbook sheets, kept out of the Show switch because they are required
export default function ReportFormDrawerExportFiltersSection() {
	return <CommonExportFiltersSection>
		<Grid item xs={4} data-tour-id="tour-sheets">
			<SheetsField/>
		</Grid>
		<Grid item xs={8}/>
	</CommonExportFiltersSection>
}
